import React from 'react'
import { GridCell, GridFilterCell } from '@progress/kendo-react-grid'
import moment from 'moment'
import { formatDate, defaultDateFormat, defaultDateTimeFormat, fromLocalToSystemTime } from '@/utils/dateUtilities'
import { DueDateWrapper } from '@/components/dueDateWrapper'
import { DatePicker } from 'antd'
import { isDefined, isDefinedAndNotEmpty } from '@/utils/isDefined'
import pascalCase from '@/utils/pascalCase'

const { RangePicker } = DatePicker

class DateCell extends GridCell {
  getTooltipFormat () { return 'LL' }
  getFormatString () { return defaultDateFormat }
  render () {
    const value = this.props.dataItem[this.props.field]
    if (value) {
      const d = moment(value)
      if (d.isValid()) {
        return (<td title={d.format(this.getTooltipFormat())}>{formatDate(d, this.getFormatString())}</td>)
      }
    }
    return (<td>-</td>)
  }
}

class DateTimeCell extends DateCell {
  getTooltipFormat () { return 'LLLL' }
  getFormatString () { return defaultDateTimeFormat }
}

class DueDateCell extends GridCell {
  getTooltipFormat () { return 'LL' }
  getFormatString () { return defaultDateFormat }
  render () {
    const value = this.props.dataItem[this.props.field]
    if (value) {
      const d = moment(value)
      if (d.isValid()) {
        return (<td className='td-due-date' title={d.format(this.getTooltipFormat())}><DueDateWrapper dueDate={d} /></td>)
      }
    }
    return (<td className='td-due-date'><span className='due-date-label undefined-date'>-</span></td>)
  }
}

class DateFilterCell extends GridFilterCell {
  onValueChange = (dates) => {
    dates.forEach((date, index) => moment.isMoment(date) ? (index === 0 ? date.utc().startOf('day') : date.utc().endOf('day')) : date)
    const hasValues = isDefined(dates) && dates.length > 0
    this.props.onChange({
      value: hasValues ? dates : '',
      operator: hasValues ? 'between' : ''
    })
  }
  render () {
    const { value } = this.props
    const title = value ? value.map(date => moment.isMoment(date) ? date.format(defaultDateFormat) : date).join(' - ') : null
    return (
      <div>
        <div className={'k-filtercell' + (isDefinedAndNotEmpty(this.props.value) ? ' k-filtercell-filtered' : '')} title={title}>
          <RangePicker value={value} onChange={this.onValueChange} format={defaultDateFormat} />
        </div>
      </div>
    )
  }
}

class DateTimeFilterCell extends GridFilterCell {
  onValueChange = (dates) => {
    dates.forEach(date => moment.isMoment(date) ? fromLocalToSystemTime(date) : date)
    const hasValues = isDefined(dates) && dates.length > 0
    this.props.onChange({
      value: hasValues ? dates : '',
      operator: hasValues ? 'between' : ''
    })
  }
  render () {
    const { value } = this.props
    const title = value ? value.map(date => moment.isMoment(date) ? date.format(defaultDateTimeFormat) : date).join(' - ') : null
    return (
      <div>
        <div className={'k-filtercell' + (isDefinedAndNotEmpty(this.props.value) ? ' k-filtercell-filtered' : '')} title={title}>
          <RangePicker value={value} onChange={this.onValueChange} format={defaultDateTimeFormat} showTime={{ format: 'HH:mm' }} />
        </div>
      </div>
    )
  }
}

function DoubleDateCell (props) {
  const getTooltipFormat = () => { return 'LL' }
  const getFormatString = () => { return defaultDateFormat }
  const getFormattedString = (date) => { return date.isValid() ? formatDate(date, getFormatString()) : '-' }

  const valueFirst = props.dataItem[props.field]
  const valueSecond = props.dataItem['duplicate' + pascalCase(props.field)]

  let dateString = ':'
  let titleString = ':'

  if (valueFirst && valueSecond && moment(valueFirst).isValid() && moment(valueSecond).isValid()) {
    const dateFirst = moment(valueFirst)
    const dateSecond = moment(valueSecond)
    dateString = `${getFormattedString(dateFirst)} : ${getFormattedString(dateSecond)}`
    titleString = `${dateFirst.format(getTooltipFormat())} : ${dateSecond.format(getTooltipFormat())}`
  } else if (valueFirst && moment(valueFirst).isValid()) {
    const dateFirst = moment(valueFirst)
    dateString = `${getFormattedString(dateFirst)} : `
    titleString = `${dateFirst.format(getTooltipFormat())} : }`
  } else if (valueSecond && moment(valueSecond).isValid()) {
    const dateSecond = moment(valueSecond)
    dateString = ` : ${getFormattedString(dateSecond)}`
    titleString = ` : ${dateSecond.format(getTooltipFormat())}`
  }
  return (<td title={titleString}>{dateString}</td>)
}

export {
  DateCell,
  DateFilterCell,
  DateTimeCell,
  DateTimeFilterCell,
  DueDateCell,
  DoubleDateCell
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/dateCells.js